import { render, staticRenderFns } from "./TaskManager.vue?vue&type=template&id=09926db6&scoped=true"
import script from "./TaskManager.vue?vue&type=script&lang=js"
export * from "./TaskManager.vue?vue&type=script&lang=js"
import style0 from "./TaskManager.vue?vue&type=style&index=0&id=09926db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09926db6",
  null
  
)

export default component.exports